import { useState, useEffect } from 'react';

export default function Navbar() {
  const [scrolled] = useState(true);
  const [mobileOpen, setMobileOpen] = useState(false);

  const navLinks = [
    { label: 'Home', href: '/' },
  ];

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white border-b border-stone-100'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 lg:px-10 flex items-center justify-between h-[72px]">
        {/* Logo */}
        <a href="/" aria-label="Carpet & Flooring Transformers Home" className="flex-shrink-0 flex items-center">
          <div className={`transition-all duration-300 rounded-lg px-2 py-1 ${scrolled ? 'bg-transparent' : 'bg-white/90'}`}>
            <img
              src="https://storage.readdy-site.link/project_files/4aabb2c2-7eb2-4ec6-b246-1cc454fd1102/b63a3b10-779d-40ea-854d-08f3c3a6fbfa_carpet-logo.jpg?v=3338a00cb738bb938410f60bd4b1db25"
              alt="Carpet & Flooring Transformers Logo"
              className="h-11 w-auto object-contain"
            />
          </div>
        </a>

        {/* Desktop Nav */}
        <nav className="hidden lg:flex items-center gap-7" itemScope itemType="https://schema.org/SiteNavigationElement">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              itemProp="url"
              className={`text-[13px] font-medium tracking-wide transition-colors cursor-pointer whitespace-nowrap ${
                scrolled ? 'text-stone-600 hover:text-stone-900' : 'text-white/80 hover:text-white'
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop Right */}
        <div className="hidden lg:flex items-center gap-5">
          <a
            href="tel:7702361255"
            className={`flex items-center gap-2 text-[13px] font-bold tracking-wide whitespace-nowrap transition-colors cursor-pointer ${
              scrolled ? 'text-stone-800 hover:text-amber-700' : 'text-white hover:text-amber-300'
            }`}
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill"></i>
            </div>
            770.236.1255
          </a>
          <a
            href="#estimate-form"
            className={`text-[13px] font-semibold px-5 py-2.5 rounded-full whitespace-nowrap transition-all cursor-pointer ${
              scrolled
                ? 'bg-stone-900 text-white hover:bg-amber-700'
                : 'bg-white/15 border border-white/40 text-white hover:bg-white hover:text-stone-900 backdrop-blur-sm'
            }`}
          >
            Free Estimate
          </a>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="lg:hidden cursor-pointer p-1"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="Toggle menu"
        >
          <div className={`w-6 h-6 flex items-center justify-center text-xl ${scrolled ? 'text-stone-800' : 'text-white'}`}>
            <i className={mobileOpen ? 'ri-close-line' : 'ri-menu-3-line'}></i>
          </div>
        </button>
      </div>

      {/* Mobile Menu */}
      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-stone-100 px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={() => setMobileOpen(false)}
              className="text-stone-700 font-medium text-sm py-1 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
          <div className="border-t border-stone-100 pt-4 flex flex-col gap-3">
            <a href="tel:7702361255" className="flex items-center gap-2 text-stone-900 font-bold text-base cursor-pointer">
              <div className="w-4 h-4 flex items-center justify-center text-amber-600">
                <i className="ri-phone-fill"></i>
              </div>
              770.236.1255
            </a>
            <a
              href="#estimate-form"
              onClick={() => setMobileOpen(false)}
              className="bg-stone-900 text-white text-center font-semibold text-sm px-5 py-3 rounded-full cursor-pointer whitespace-nowrap"
            >
              Request Free Estimate
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
